import { StudyData } from "./deviceProgress";

export function plainRecord(feature: string, value: unknown): StudyData {
    if (!value || typeof value !== "object" || Array.isArray(value)) return {};
    const entries = Object.entries(value).filter(([key]) => !["__proto__", "constructor", "prototype"].includes(key));
    if (feature === "lessonParagraphNotes") return Object.fromEntries(entries.filter(([, note]) => {
        const data = note as { text?: unknown; updatedAt?: unknown } | null;
        return data && typeof data.text === "string" && typeof data.updatedAt === "string";
    }));
    if (feature === "kanjiMemoryGuessStats") return Object.fromEntries(entries.filter(([, data]) => data && typeof data === "object" && !Array.isArray(data)).map(([key, data]) => [key, plainRecord("counts", data)]));
    if (feature.endsWith("Counts") || feature === "counts") return Object.fromEntries(entries.filter(([, count]) => typeof count === "number" && Number.isFinite(count) && count >= 0));
    return Object.fromEntries(entries.filter(([, item]) => typeof item === "string"));
}
